import React from 'react';

const SpeakerUpdatePricing = () => {
  const codes = {
    'Keynote Talk (30–60 mins)': {
      offerPrice: 'Negotiable',
      topics: [
        'Ideal for conferences, summits, or opening/closing sessions.',
      ],
    },
    'Half-Day Workshop (3–4 hours)': {
      offerPrice: 'Negotiable',
      topics: [
        'Perfect for organizations, leadership teams, or entrepreneurship bootcamps.',
      ],
    },
    'Full-Day Workshop / Retreat (6–8 hours)': {
      offerPrice: 'Negotiable',
      topics: [
        'In-depth, transformational experience for serious entrepreneurs or leadership groups.',
      ],
    },
    'Online Masterclass / Virtual Session (60–90 mins)': {
      offerPrice: 'Negotiable',
      topics: [
        'Scalable & flexible for virtual summits or remote teams.',
      ],
    },
    'Private Corporate Training / Custom Event': {
      offerPrice: 'Negotiable',
      topics: [
        'Tailored for brands, corporate teams, or investor forums.',
      ],
    }
  };

       const boxStyle = {
    flex: '1 1 400px', // <-- Base width for the card
    padding: '20px',
    border: '1px solid violet',
    backgroundColor: 'rgba(238, 130, 238, 0.1)',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };

  const buttonStyle = {
    marginTop: '20px',
    padding: '10px 20px',
    backgroundColor: 'purple',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px',
  };

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
        {Object.entries(codes).map(([codeTitle, { offerPrice, topics }]) => (
          <div key={codeTitle} style={boxStyle}>
            <div>
              <h3 style={{ color: '', marginBottom: '10px' }} className='text-center'>{codeTitle}</h3>
              <ul style={{ paddingLeft: '20px' }}>
                {topics.map((topic, idx) => (
                  <h4 key={idx} style={{ marginBottom: '8px' }}>{topic}</h4>
                ))}
              </ul>
            </div>
            <div style={{ marginTop: 'auto' }}>
              <h4 style={{ margin: '20px 0 10px 0' }}>
                Fee:
                <span style={{ color: 'green', fontWeight: 'bold', paddingLeft: '10px' }}>{offerPrice}</span>
              </h4>
              {/* <button className='btn-default'>Purchase</button> */}
            </div>
          </div>
        ))}

      </div>
      {/* <div className="w-full text-center px-5 mt-5 pt-5">
        <h5 className="">
          <strong>**Spots are limited. Every consulting package is selectively offered to ensure results. Apply now to book your session.**</strong>
        </h5>
      </div> */}
    </div>

  );
};

export default SpeakerUpdatePricing;
